import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=0d55bdb4&scoped=true"
import script from "./DocumentList.vue?vue&type=script&lang=js"
export * from "./DocumentList.vue?vue&type=script&lang=js"
import style0 from "./DocumentList.vue?vue&type=style&index=0&id=0d55bdb4&prod&lang=scss&scoped=true"
import style1 from "./DocumentList.vue?vue&type=style&index=1&id=0d55bdb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d55bdb4",
  null
  
)

export default component.exports